import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
// import { common } from '../common'
import List from '../menu/list'
import Link, { CategoryLink } from '../menu/link'
import Dropdown from '../dropdown/index'
import { CategoryInfo } from './Types'
import Icon from '../assets'
// @ts-expect-error   // fix this by defining the mapping to 'downshift' in tsconfig
import Downshift from 'downshift/preact'
import { ControllerStateAndHelpers } from 'downshift'
import { TranslationCategory } from '../../libs/translationsUtils/translations'

export interface MenuQuicklink {
  url: string
  phrase: {
    m: TranslationCategory
    p: string
  }
}

interface Props {
  name: string
  categories: CategoryInfo[]
  popupName: string
  quickLinks: Array<MenuQuicklink|null>
}

function isNotNull (i: MenuQuicklink|null): i is MenuQuicklink {
  return !!i
}

const trackParentCategory = (title: string, url: string) => {
  return {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: 'parent category'
  }
}

const gaEvents = (url: string) => {
  return {
    eventCategory: 'Homepage',
    eventAction: 'Menu clicked',
    eventLabel: {
      Link: url
    }
  }
}

const trackCategory = (title: string, url: string) => {
  return {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: 'category'
  }
}

const CategoryMenu = ({
  categories,
  name,
  popupName,
  quickLinks
}: Props) => (
  <li class='header-navigation_list-item main-menu'>
    <Downshift onChange={(item: {url: string}) => { window.location.href = item.url }}>
      {({
        getItemProps,
        getInputProps,
        getRootProps,
        highlightedIndex,
        selectHighlightedItem,
        setHighlightedIndex
      }: ControllerStateAndHelpers<{url: string}>) => {
        const quickLinksClean = quickLinks.filter(isNotNull)
        const categoryList = categories.reduce<CategoryInfo[]>((categoryList, parentCategory) => {
          return categoryList.concat(parentCategory).concat(parentCategory.subforums || [])
        }, [])
        const isHighlighted = (idx: number) => idx === highlightedIndex

        const onGlobalKey = (direction: 'up'|'down'|'enter') => {
          if (direction === 'enter') return selectHighlightedItem()
          if (highlightedIndex === null) return setHighlightedIndex(0)
          let newIndex = highlightedIndex + (direction === 'up' ? -1 : 1)
          if (newIndex < 0) newIndex = 0
          const maxIndex = quickLinksClean.length + categoryList.length - 1
          if (newIndex >= maxIndex) newIndex = maxIndex
          setHighlightedIndex(newIndex)
        }

        return (
          <Dropdown
            popupName={popupName}
            class='dropdown dropdown--forums-overview'
            onGlobalKey={onGlobalKey}
            trigger={
              <span style={{ display: 'flex', alignItems: 'center' }} class='main-menu-trigger' {...getRootProps({ refKey: 'menu-trigger' }, { suppressRefError: true })} {...getInputProps()}>
                <span>{name}</span>
                <Icon icon='chevronDown' width={16} height={16} />
              </span>
            }
          >
            <li aria-hidden='true' class='arrow is-hidden-S' />

            <li class='main-menu-list--overflow-scroll'>
              {quickLinksClean.length
                ? <List
                    class='main-menu-list--quiclinks'
                    getItemProps={(idx) => getItemProps({
                      item: quickLinksClean[idx],
                      class: `main-menu-list__item main-menu-list__item--no-hover ${isHighlighted(idx) ? 'main-menu-list__item--highlighted' : ''
                  }`
                    })}
                  >
                  {quickLinksClean.map(item => {
                    return (
                      <Link key={item.url} href={item.url}>
                        <Phrase {...item.phrase} />
                      </Link>
                    )
                  })}
                </List>
                : null}

              {categoryList.length
                ? (
                  <List getItemProps={(idx) => getItemProps({
                    item: categoryList[idx],
                    class: `main-menu-list__item main-menu-list__item--no-hover ${isHighlighted(quickLinksClean.length + idx) ? 'main-menu-list__item--highlighted' : ''
                  }`
                  })}
                  >
                    {categoryList.map((category) => {
                      const isParent = !!category.subforums?.length
                      return (
                        <CategoryLink
                          key={category.id}
                          track={(isParent ? trackParentCategory : trackCategory)(category.title, category.url)}
                          gaEvents={gaEvents(category.url)}
                          href={category.url}
                          title={category.title}
                          topicsCount={isParent ? undefined : category.topicCount}
                        >
                          {isParent ? <strong>{category.title}</strong> : category.title}
                        </CategoryLink>
                      )
                    })}
                  </List>
                  )
                : null}
            </li>
          </Dropdown>
        )
      }}
    </Downshift>
  </li>
)

export default CategoryMenu
